import { render, staticRenderFns } from "./QrcodeReader.vue?vue&type=template&id=365c3cd6&"
import script from "./QrcodeReader.vue?vue&type=script&lang=js&"
export * from "./QrcodeReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports